import * as path from "node:path";
import { buildCustomTypeLibraryDirectoryPath } from "./buildCustomTypeLibraryDirectoryPath.js";
const buildCustomTypeDirectoryPath = (args) => {
  return path.join(buildCustomTypeLibraryDirectoryPath(args), args.customTypeID);
};
export {
  buildCustomTypeDirectoryPath
};
//# sourceMappingURL=buildCustomTypeDirectoryPath.js.map
